import styled from 'styled-components';

import { customScrollbar } from '@/styles/style';

import ChartDetailRenderSectionCharts from './body.render-section.charts';

type Props = {
  chartInfo: ChartContextProps;
};

export default function ChartDetailRenderSection({ chartInfo }: Props) {
  return (
    <ChartDetailRenderSectionStyle>
      <div className="flex flex-col flex-1 shrink-0 w-full h-full pr-8">
        <ChartDetailRenderSectionCharts chartInfo={chartInfo} />
      </div>
    </ChartDetailRenderSectionStyle>
  );
}

const ChartDetailRenderSectionStyle = styled.div`
  flex: 1;
  padding-right: 24px;
  overflow: auto;
  scrollbar-gutter: stable;
  ${customScrollbar};
`;
